import { fork, put, all, call, takeLatest, delay } from "redux-saga/effects";

import {
  GET_ORG_ACCOUNTS,
  UPDATE_ORG_ACCOUNT,
  ADD_ORG_ACCOUNT,
  DELETE_ORG_ACCOUNT,
  DELETE_ORG_USER,
  CLEAR_ALL_MESSAGES,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_FAILURE_MESSAGES,
  GET_ORG_ACCOUNT_WORKLOADS,
  UPDATE_ORG_ACCOUNT_WORKLOAD,
  GET_SCAN_SCHEDULES,
  UPDATE_SCAN_SCHEDULE_FREQUENCY,
  POST_FEATURE_CONFIGURATION
} from "./actionTypes"

import {
  getOrgAccounts as getOrgAccountsAction,
  getOrgAccountsSuccess,
  getOrgAccountsFailure,
  getOrgUsersSuccess,
  getOrgSuccess,
  updateOrgAccount as updateOrgAccountAction,
  updateOrgAccountSuccess,
  updateOrgAccountFailure,
  addOrgAccount as addOrgAccountAction,
  addOrgAccountSuccess,
  addOrgAccountFailure,
  deleteOrgAccount as deleteOrgAccountAction,
  deleteOrgAccountSuccess,
  deleteOrgAccountFailure,
  deleteOrgUser as deleteOrgUserAction,
  deleteOrgUserSuccess,
  deleteOrgUserFailure,
  clearAllOrgAcctMessagesSuccess as clearAllMessagesSuccessAction,
  clearSuccessOrgAcctMessagesSuccess as clearSuccessMessagesSuccessAction,
  clearFailureOrgAcctMessagesSuccess as clearFailureMessagesSuccessAction,
  getOrgAccountWorkloads as getOrgAccountWorkloadsAction,
  getOrgAccountWorkloadsSuccess,
  getOrgAccountWorkloadsFailure,
  updateOrgAccountWorkload as updateOrgAccountWorkloadAction,
  updateOrgAccountWorkloadSuccess,
  updateOrgAccountWorkloadFailure,
  getScanSchedules as getScanSchedulesAction,
  getScanSchedulesSuccess,
  getScanSchedulesFailure,
  updateScanScheduleFrequency as updateScanScheduleFrequencyAction,
  updateScanScheduleFrequencySuccess,
  updateScanScheduleFrequencyFailure,
  postFeatureConfiguration as postFeatureConfigurationAction,
  postFeatureConfigurationSuccess,
  postFeatureConfigurationFailure,
} from "./actions";

import {
  getOrgAccounts as getOrgAccountsApi,
  updateOrgAccount as updateOrgAccountApi,
  addOrgAccount as addOrgAccountApi,
  deleteOrgAccount as deleteOrgAccountApi,
  deleteOrgUser as deleteOrgUserApi,
  getOrgAccountWorkloads as getOrgAccountWorkloadsApi,
  updateOrgAccountWorkload as updateOrgAccountWorkloadApi,
  getScanSchedules as getScanSchedulesApi,
  updateScanScheduleFrequency as updateScanScheduleFrequencyApi,
  postFeatureConfiguration as postFeatureConfigurationApi,
} from "../../helpers/auth_helper"

function* getOrgAccounts ({ payload: { orgCode }}){
  try{
    console.log("Saga, getOrgAccounts, Organization Code:: ", orgCode);
    const response = yield call(getOrgAccountsApi, orgCode);
    console.log("getOrgAccountsApi called, received response: ", response);
    if(response && response.status === 200){
      yield put(getOrgAccountsSuccess(response?.accounts));
      yield put(getOrgUsersSuccess(response?.users));
      yield put(getOrgSuccess(response?.organizations?.[0]));
    }else{
      yield put(getOrgAccountsFailure({message: response.message}));
    }
  } catch(error){
    console.log("getOrgAccountsApi called, received Error is :: ", JSON.stringify(error));
    if(error.response){
      yield put(getOrgAccountsFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getOrgAccountsFailure({message: "No response is received"}))
    } else{
      yield put(getOrgAccountsFailure({message: error?.message}));
    }
  }
}

function* updateOrgAccount({ payload: { updateOrgAccountPayload } }) {
  try {
    console.log(
      "Saga, updateOrgAccount, Organization Account:: ",
      updateOrgAccountPayload.subscription
    );
    const response = yield call(updateOrgAccountApi, updateOrgAccountPayload);
    console.log("updateOrgAccountApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(updateOrgAccountSuccess());
    } else {
      let message;
      if (response?.data?.message) {
        message = response?.data?.message;
      } else {
        message = response?.data;
      }
      yield put(updateOrgAccountFailure({message: message}));
    }
  } catch (error) {
    console.log(
      "updateOrgAccountApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      console.log("updateOrgAccount error.response=", error.response);
      yield put(        
        updateOrgAccountFailure({message: message})
      );
    } else if (error.request) {
      yield put(
        updateOrgAccountFailure({ message: "No response is received" })
      );
    } else {
      yield put(updateOrgAccountFailure({ message: error?.message }));
    }
  }
}

function* addOrgAccount({ payload: { addOrgAccountPayload } }) {
  try {
    console.log(
      "Saga, addOrgAccount, Organization Account:: ",
      addOrgAccountPayload
    );
    const response = yield call(addOrgAccountApi, addOrgAccountPayload);
    console.log("addOrgAccountApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(addOrgAccountSuccess());
    } else {
      let message;
      if (response?.data?.message) {
        message = response?.data?.message;
      } else {
        message = response?.data;
      }
      yield put(addOrgAccountFailure({message: message}));
    }
  } catch (error) {
    console.log(
      "addOrgAccountApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      console.log("addOrgAccount error.response=", error.response);
      yield put(        
        addOrgAccountFailure({message: message})
      );
    } else if (error.request) {
      yield put(
        addOrgAccountFailure({ message: "No response is received" })
      );
    } else {
      yield put(addOrgAccountFailure({ message: error?.message }));
    }
  }
}

function* deleteOrgAccount({ payload: { orgCode, orgAccountCode } }) {
  try {
    console.log(
      "Saga, deleteOrgAccount, Organization Account Code:: ",
      orgAccountCode
    );
    const response = yield call(deleteOrgAccountApi, {orgCode, orgAccountCode});
    console.log("deleteOrgAccountApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(deleteOrgAccountSuccess());
      yield delay(2000);
      yield put(getOrgAccountsAction(orgCode));
    } else {
      let message;
      if(response.message){
        message = response.message;
      }else{
        message = response;
      }
      yield put(deleteOrgAccountFailure({message: message}));
    }
  } catch (error) {
    console.log(
      "deleteOrgAccountApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      yield put(
        deleteOrgAccountFailure({
          message:
            "Error Code: " +
            error.response?.status +
            ", Message: " +
            error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(
        deleteOrgAccountFailure({ message: "No response is received" })
      );
    } else {
      yield put(deleteOrgAccountFailure({ message: error?.message }));
    }
  }
}

function* deleteOrgUser({ payload: { orgCode, email } }) {
  try {
    console.log("Saga, deleteOrgUser, Username :: ", email);
    const response = yield call(deleteOrgUserApi, email, orgCode);
    console.log("deleteOrgUserApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(deleteOrgUserSuccess());
      yield delay(2000);
      // To refresh data grids: org accounts and org users
      yield put(getOrgAccountsAction(orgCode));
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(deleteOrgUserFailure({ message: message }));
    }
  } catch (error) {
    console.log("deleteOrgUserApi called, received Error is :: ", JSON.stringify(error) );
    if (error.response) {
      yield put(
        deleteOrgUserFailure({
          message: "Error Code: " + error.response?.status + ", Message: " +
            error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(
        deleteOrgUserFailure({ message: "No response is received" })
      );
    } else {
      yield put(deleteOrgUserFailure({ message: error?.message }));
    }
  }
}

export function* clearAllMessages() {
  console.log("Saga: clear all messages");
  yield put(clearAllMessagesSuccessAction());
}

export function* clearSuccessMessages() {
  console.log("Saga: clear success messages");
  yield put(clearSuccessMessagesSuccessAction());
}

export function* clearFailureMessages() {
  console.log("Saga: clear failure messages");
  yield put(clearFailureMessagesSuccessAction());
}

function* getOrgAccountWorkloads({ payload: { accountNumber } }) {
  try {
    console.log("Saga, getOrgAccountWorkloads, Account Number:: ", accountNumber);
    const response = yield call(getOrgAccountWorkloadsApi, accountNumber);
    console.log("getOrgAccountWorkloadsApi called, received response: ", response);
    
    // Check if response is an Error object (from api_helper.js)
    if (response instanceof Error) {
      // Extract custom message from error.response.data.message or error.response.data.error.message
      const responseData = response.response?.data;
      const customMessage = responseData?.message || responseData?.error?.message;
      const finalMessage = customMessage || response.message;
      console.log("Final error message:", finalMessage);
      yield put(getOrgAccountWorkloadsFailure({ message: finalMessage }));
    } else if (response && response.status === 200) {
      // Success case
      const workloadsData = response?.data?.data || response?.data || response;
      yield put(getOrgAccountWorkloadsSuccess(workloadsData));
    } else {
      // Non-200 status case
      const message = response?.data?.message || response?.data || "Unknown error";
      yield put(getOrgAccountWorkloadsFailure({ message: message }));
    }
  } catch (error) {
    // This should rarely happen now, but keeping as fallback
    const message = error.response?.data?.message || error.message || "Unknown error";
    yield put(getOrgAccountWorkloadsFailure({ message: message }));
  }
}

function* updateOrgAccountWorkload({ payload: { accountNumber, workloadId, automationRunLimitPerDay } }) {
  try {
    console.log("Saga, updateOrgAccountWorkload, Account Number:: ", accountNumber, "Workload ID:: ", workloadId, "Automation Run Limit:: ", automationRunLimitPerDay);
    const requestData = {
      accountNumber,
      workloadId,
      automationRunLimitPerDay
    };
    const response = yield call(updateOrgAccountWorkloadApi, requestData);
    console.log("updateOrgAccountWorkloadApi called, received response: ", response);
    console.log("response.data:", response?.data);
    console.log("response.status:", response?.status);
    
    if (response && response.status === 200) {
      // The response data is directly in response.data, not nested
      const responseData = response.data || response;
      console.log("Sending responseData to success action:", responseData);
      yield put(updateOrgAccountWorkloadSuccess(responseData));
    } else {
      yield put(updateOrgAccountWorkloadFailure({ message: response.message }));
    }
  } catch (error) {
    console.log("updateOrgAccountWorkloadApi called, received Error is :: ", JSON.stringify(error));
    if (error.response) {
      yield put(updateOrgAccountWorkloadFailure({ message: "Error Code: " + error.response?.status + ", Message: " + error.response?.data }));
    } else if (error.request) {
      yield put(updateOrgAccountWorkloadFailure({ message: "No response is received" }));
    } else {
      yield put(updateOrgAccountWorkloadFailure({ message: error?.message }));
    }
  }
}

function* getScanSchedules({ payload: { orgCode, accountCode } }) {
  try {
    console.log("Saga, getScanSchedules, orgCode:: ", orgCode, "accountCode:: ", accountCode);
    const response = yield call(getScanSchedulesApi, orgCode, accountCode);
    console.log("getScanSchedulesApi called, received response: ", response);
    
    // Check if response is an Error object (from api_helper.js)
    if (response instanceof Error) {
      // Extract custom message from error.response.data.message or error.response.data.error.message
      const responseData = response.response?.data;
      const customMessage = responseData?.message || responseData?.error?.message;
      const finalMessage = customMessage || response.message;
      console.log("Final error message:", finalMessage);
      yield put(getScanSchedulesFailure({ message: finalMessage }));
    } else if (response && response.status === 200) {
      // The get() helper spreads array data into object with numeric keys {0: {}, 1: {}, ..., status: 200}
      // We need to extract the array items and filter out the status field, preserving order
      const schedules = [];
      const numericKeys = Object.keys(response)
        .filter(key => key !== 'status' && !isNaN(parseInt(key)))
        .map(key => parseInt(key))
        .sort((a, b) => a - b);
      
      numericKeys.forEach(key => {
        schedules.push(response[key]);
      });
      
      console.log("Extracted schedules array:", schedules);
      yield put(getScanSchedulesSuccess(schedules));
    } else {
      // Non-200 status case
      const message = response?.data?.message || response?.data || "Unknown error";
      yield put(getScanSchedulesFailure({ message: message }));
    }
  } catch (error) {
    // This should rarely happen now, but keeping as fallback
    const message = error.response?.data?.message || error.message || "Unknown error";
    yield put(getScanSchedulesFailure({ message: message }));
  }
}

function* updateScanScheduleFrequency({ payload: { orgCode, accountCode, scheduleId, frequency, status, auditScanLimit } }) {
  try {
    console.log("Saga, updateScanScheduleFrequency, orgCode:: ", orgCode, "accountCode:: ", accountCode, "scheduleId:: ", scheduleId, "frequency:: ", frequency, "status:: ", status, "auditScanLimit:: ", auditScanLimit);
    // Always send schedule_id, frequency, and status; include auditScanLimit when provided
    const requestData = {
      schedule_id: scheduleId,
      frequency: frequency,
      status: status,
      ...(auditScanLimit !== undefined && auditScanLimit !== null && { auditScanLimit }),
    };
    const response = yield call(updateScanScheduleFrequencyApi, orgCode, accountCode, requestData);
    console.log("updateScanScheduleFrequencyApi called, received response: ", response);
    console.log("response.data:", response?.data);
    console.log("response.status:", response?.status);
    
    if (response && response.status === 200) {
      const responseData = response.data || response;
      console.log("Sending responseData to success action:", responseData);
      // responseData is typically a string message, so we pass schedule fields separately
      yield put(updateScanScheduleFrequencySuccess({ 
        message: typeof responseData === 'string' ? responseData : "Scan schedule updated successfully!",
        schedule_id: scheduleId, 
        frequency: frequency,
        status: status,
        ...(auditScanLimit !== undefined && auditScanLimit !== null && { auditScanLimit }),
      }));
    } else {
      yield put(updateScanScheduleFrequencyFailure({ message: response.message || "Failed to update schedule frequency" }));
    }
  } catch (error) {
    console.log("updateScanScheduleFrequencyApi called, received Error is :: ", JSON.stringify(error));
    if (error.response) {
      yield put(updateScanScheduleFrequencyFailure({ message: "Error Code: " + error.response?.status + ", Message: " + error.response?.data }));
    } else if (error.request) {
      yield put(updateScanScheduleFrequencyFailure({ message: "No response is received" }));
    } else {
      yield put(updateScanScheduleFrequencyFailure({ message: error?.message }));
    }
  }
}

function* postFeatureConfiguration({ payload: { featureConfigPayload } }) {
  try {
    console.log("Saga, postFeatureConfiguration, payload:: ", featureConfigPayload);
    const response = yield call(postFeatureConfigurationApi, featureConfigPayload);
    console.log("postFeatureConfigurationApi called, received response: ", response);
    if (response && response.status === 200) {
      const responseData = response?.data || response;
      yield put(postFeatureConfigurationSuccess(responseData));
    } else {
      let message;
      if (response?.data?.message) {
        message = response?.data?.message;
      } else {
        message = response?.data || "Failed to submit feature configuration";
      }
      yield put(postFeatureConfigurationFailure({ message: message }));
    }
  } catch (error) {
    console.log("postFeatureConfigurationApi called, received Error is :: ", JSON.stringify(error));
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      yield put(postFeatureConfigurationFailure({ message: message }));
    } else if (error.request) {
      yield put(postFeatureConfigurationFailure({ message: "No response is received" }));
    } else {
      yield put(postFeatureConfigurationFailure({ message: error?.message }));
    }
  }
}

function* watchOrgAccounts(){
  yield takeLatest(GET_ORG_ACCOUNTS, getOrgAccounts);
  yield takeLatest(UPDATE_ORG_ACCOUNT, updateOrgAccount);
  yield takeLatest(ADD_ORG_ACCOUNT, addOrgAccount);
  yield takeLatest(DELETE_ORG_ACCOUNT, deleteOrgAccount);
  yield takeLatest(DELETE_ORG_USER, deleteOrgUser);
  yield takeLatest(GET_ORG_ACCOUNT_WORKLOADS, getOrgAccountWorkloads);
  yield takeLatest(UPDATE_ORG_ACCOUNT_WORKLOAD, updateOrgAccountWorkload);
  yield takeLatest(GET_SCAN_SCHEDULES, getScanSchedules);
  yield takeLatest(UPDATE_SCAN_SCHEDULE_FREQUENCY, updateScanScheduleFrequency);
  yield takeLatest(POST_FEATURE_CONFIGURATION, postFeatureConfiguration);
  yield takeLatest(CLEAR_ALL_MESSAGES, clearAllMessages);
  yield takeLatest(CLEAR_SUCCESS_MESSAGES, clearSuccessMessages);
  yield takeLatest(CLEAR_FAILURE_MESSAGES, clearFailureMessages);  
}

function* orgAccountSaga(){
  yield all([fork(watchOrgAccounts)]);

}

export default orgAccountSaga;